<template>
    <b-modal
        id="chapter-modal"
        centered 
        size="lg"
        body-class="d-flex flex-column p-3 f-narkis"
        header-class="bg-primary text-white"
        footer-class="border-top"
        ok-variant="secondary"
        :ok-title="hebrew ? 'סגור' : 'Close'"
        ok-only
        v-model="show"
        @show="scrollIntoView"
    >
        <template slot="modal-header">
          <h3 class="my-0">
           <span v-if="srcItem.compName.includes('Ben-Yehuda')">
            {{srcItem.compNameHe.split(',')[2]+ ', ' +srcItem.compNameHe.split(',')[3]}}
          </span>
          <span v-else>  
            {{srcItem.compNameHe.split(':')[2]+ ', ' +srcItem.compNameHe.split(':')[3]}}
          </span>
          </h3>
          <small v-if="srcItem.url"><a class="text-white" :href="srcItem.url" target="_blank" rel="noopener noreferrer">
            <span v-if="srcItem.url.includes('benyehuda')">{{hebrew ? 'צפה בטקסט המקורי בפרויקט בן-יהודה ' : 'View more on the Ben Yehuda project'}}</span>
            <span v-else>{{hebrew ? 'צפה בפרושים וחידושים [ספריא] ' : 'View more on Sefaria'}}</span>            
          </a></small>
        </template>
        <div class="text-right px-2" v-html="srcItem.compMatchedText"></div>
    </b-modal>
</template>

<script>
export default {
  name: 'ChapterPopup',
  props: ['value','srcItem'],
  mounted () {
  },
  methods: {
    scrollIntoView () {
      this.$nextTick(() => {
        if (document.getElementById("matched-text"))
          document.getElementById("matched-text")
            .scrollIntoView({ behavior: "smooth", block: "start" })
      })  
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },     
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
  .text-right{
    max-height: 70vh;
    overflow-y: auto;
  }
 
  .pasuk-header{
    font-family: 'Arimo';
  }
</style>
